import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';

const JobSettings: React.FC = () => {
    const settings: SettingsSettingType[] = [
        {
            title: 'job.settings.appointment_method_title',
            explanationText: 'job.settings.appointment_method_explanation',
            fields: [
                {
                    type: 'tabs',
                    name: 'job_appointment_method',
                    buttonSize: 'large',
                    options: [
                        { value: 'single', name: 'job.settings.single_jobs_option' },
                        { value: 'multiple', name: 'job.settings.multiple_appointments_option', requiredFeature: 'job_multiple_appointments' },
                    ]
                }
            ]
        },
        {
            title: 'job.settings.default_billing_type_title',
            scope: 'division',
            explanationText: 'job.settings.default_billing_type_explanation',
            fields: [
                {
                    type: 'dropdown',
                    name: 'job_default_billing_type',
                    allowNoneOption: false,
                    showSearch: false,
                    hardcodedOptions: [
                        { value: 'calculation', name: 'job.settings.calculation_billing_option' },
                        { value: 'fixed', name: 'job.settings.fixed_billing_option' },
                        { value: 'non_billing', name: 'job.settings.non_billing_option' }
                    ]
                }
            ]
        },
        {
            title: 'job.settings.time_registration_mode_title',
            scope: 'division',
            explanationText: 'job.settings.time_registration_mode_explanation',
            fields: [
                {
                    type: 'tabs',
                    name: 'job_time_registration_mode',
                    buttonSize: 'large',
                    options: [
                        { value: 'start-end', name: 'job.settings.start_end_time_option' },
                        { value: 'duration', name: 'job.settings.duration_option' },
                    ]
                }
            ]
        },
        {
            title: 'job.settings.numbering_scheme_title',
            explanationText: 'job.settings.numbering_scheme_explanation',
            fields: [
                {
                    type: 'text',
                    label: 'settings.general.number_sequence_title',
                    name: 'job_numbering_scheme',
                    placeholder: '',
                    group: 'field-row',
                    width: '30%',
                    shouldAutoFocus: false,
                },
                {
                    type: 'number',
                    label: 'settings.general.next_number_label',
                    name: 'job_current_number',
                    group: 'field-row',
                    width: '30%',
                }
            ]
        },
        {
            title: 'job.settings.create_jobs_via_office_title',
            explanationText: 'job.settings.create_jobs_via_office_explanation',
            switchButton: {
                enabled: true,
                name: 'job_create_jobs',
            }
        },
    ];

    return (
        <SettingsContainer settings={settings} />
    );
};

export default JobSettings;